<div class="container-filtro-principal" [class.expandido]="animacao">
  <form class="d-flex gap-2" *ngIf="filtroAberto" [formGroup]="formularioFiltros">
    <div class="container-filtros">
      <ul>
        <li>
          <div class="filtro-mapa dropdown-arrow">
            <img src="assets/mapa/filtros/usuario.png" alt="cliente">
            <select class="campo-input" [value]="clienteSelecionadoId" formControlName="clienteId" (change)="onChangeCliente($event)">
              <option *ngFor="let cliente of clientesDisponiveis" [value]="cliente.id">
                {{ cliente.nome }}
              </option>
            </select>
          </div>
        </li>
 
        <li>
          <div class="filtro-mapa dropdown-arrow">
            <img src="assets/mapa/filtros/fazenda.png" alt="fazenda">
            <select class="campo-input" formControlName="fazendaId" (change)="onChangeFazenda($event)">
              <option [value]="null">
                {{ 'COMPONENTS.MAPA.FILTER.all_farms' | transloco }}
              </option>
              <option *ngFor="let fazenda of fazendasDisponiveis" [value]="fazenda.sr_id">
                {{ fazenda.vc_nome }}
              </option>
            </select>
          </div>
        </li>
 
        <li>
          <div class="filtro-mapa dropdown-arrow">
            <img src="assets/mapa/filtros/operacao.png" alt="operacao">
            <select class="campo-input" formControlName="operacaoId">
              <option [value]="null">
                {{ 'COMPONENTS.MAPA.FILTER.all_operations' | transloco }}
              </option>
              <option *ngFor="let operacao of operacoesDisponiveis" [value]="operacao.sr_id">
                {{ operacao.vc_service_id }}
              </option>
            </select>
          </div>
        </li>
 
        <li>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <div class="filtro-mapa filtro-data">
            <img src="assets/mapa/filtros/data.png" alt="data">
            <span *ngIf="!formularioFiltros.get('dataInicio')?.value" class="placeholder-label">
              {{ 'COMPONENTS.MAPA.FILTER.period' | transloco }}
            </span>
 
            <mat-date-range-input [rangePicker]="picker" [formGroup]="formularioFiltros" [max]="dataMax">
              <input class="input-date" matStartDate formControlName="dataInicio" (dateChange)="atualizarDataMax()">
              <input class="input-date" matEndDate formControlName="dataFim">
            </mat-date-range-input>

            <button type="button" class="campo-input date-trigger" (click)="picker.open()"></button>
          </div>
        </li>
      </ul>
    </div>
 
    <button class="btn-filtrar" (click)="aplicarFiltros()" [disabled]="carregandoFiltros">
      <div [hidden]="!carregandoFiltros" class="loader"></div>
      <span [hidden]="carregandoFiltros">
        {{ 'COMPONENTS.MAPA.FILTER.filter_button' | transloco }}
      </span>
    </button>
  </form>
 
  <button type="button" class="btn btn-light btn-mapa" (click)="alternarFiltro()">
    <app-icon [aberto]="filtroAberto"></app-icon>
  </button>
</div> 